// extracted by css-extract-rspack-plugin
export default {"action":"action-TtyH7W","content":"content-BMFHGs","icon":"icon-Wf23Cb","arrow":"arrow-MyJA7A"};